export default __webpack_public_path__ + "static/media/image-icon.134fe9bb.svg";